import React, { useState, useEffect } from 'react';
import Navbar from './Navbar'; // ✅ Import the Navbar component
import { Helmet } from 'react-helmet-async';
import taxi from './belfast-cab-tour-contact.png';
import '../Styles.css';

const ContactUs = () => {
  const [scrollTop, setScrollTop] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollTop(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      id="contact-us-page"
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        margin: 0,
        padding: 0,
      }}
    >

      <Helmet>
      <title>Contact Belfast Taxi Tours | Book Your Black Cab Tour Today</title>
      <meta
       name="description"
       content="Get in touch with Belfast Taxi Tours to book your black cab experience, ask questions, or customize your sightseeing tour of Belfast and Northern Ireland. We're here to help."
      />
      </Helmet>


      {/* ✅ Fixed Navbar */}
      <Navbar />

      {/* ✅ Header section with marginTop to account for navbar height */}
      <header
        className="ContactUs-header"
        style={{
          marginTop: '60px', // Prevents overlap with fixed Navbar
        }}
      >
        <div className="animation-wrapper">
          <img
            src={taxi}
            className="taxi"
            alt="taxi"
            style={{
              top: '-2%',
              transform: `translateY(-${scrollTop / 100}%)`,
            }}
          />
        </div>
      </header>

      {/* ✅ Main Contact Content */}
      <main
        style={{
          textAlign: 'center',
          flexGrow: 1,
          padding: '1rem',
        }}
      >
        <h1 className="ContactUs-header1" style={{ marginBottom: 0 }}>
          <a href="tel:+447773600624" className="call-us-button">
            <i className="fas fa-phone-alt"></i> Call us +447773600624
          </a>
          <br />
          <a
            href="https://wa.me/+447773600624?text=Hello%2C%20I%20need%20more%20info"
            target="blank"
            className="whatsapp-button"
          >
            <i className="fab fa-whatsapp"></i> Click to message us on WhatsApp!
          </a>
        </h1>
      </main>

      {/* ✅ Footer */}
      <footer
        style={{
          textAlign: 'center',
          padding: '1rem',
          backgroundColor: '#333',
          color: '#fff',
          marginTop: 'auto',
        }}
      >
        &copy; 2025{' '}
        <a
          href="https://belfastcabtour.com"
          style={{
            color: '#fff',
            textDecoration: 'none',
          }}
        >
          belfastcabtour.com
        </a>
        . All rights reserved.
      </footer>
    </div>
  );
};

export default ContactUs;
